module.exports = __webpack_public_path__ + "media/images/svg/filter-2031bee2e5cf0dc191627dd33aa21449.svg";